<template>
  <div class="menus-main" :style="{ width: menuOpen ? `${menuWidth}px` : `${menuWidthCollapse}px`, maxWidth: menuOpen ? `${menuWidth}px` : `${menuWidthCollapse}px`, minWidth: menuOpen ? `${menuWidth}px` : `${menuWidthCollapse}px`,
    paddingTop: menuOpen ? '5px' : '33px' }">
    <img class="close-btn" src="https://img.icons8.com/material-rounded/96/000000/double-left.png" :style="{ transform: menuOpen ? `rotate(0deg)` : 'rotate(-180deg)',
      right: menuOpen ? '5px' : '' }" @click="menuOpen ^= true"/>
    <img class="icon" :src="icon" :style="{ opacity: hideIcon && menuOpen ? 0 : 1, display: !menuOpen && hideIcon ? 'none' : '' }">
    
    <slot v-if="menuOpen || !$slots.default">
      <div class="menu-box-container">
        <div class="menu-box" v-for="(m, i) in menu" :key="i">
          <button v-if="m['visible'] != false" @mousemove="menuMouseMove(m.title)" @mouseout="showTooltip = ''" :disabled="m['enabled'] == false"
            @click="$emit('menuClicked', m)">
            <img class="menu-icon" :src="m['icon']" alt="" :style="{ opacity : m['enabled'] == false ? '0.5' : 1 }">
            <div :style="{ whiteSpace: titleWrap }">{{ m['title'] }}</div>
            <div v-if="!menuOpen && showTooltip == m.title" class="menu-hover">{{ m.title }}</div>
          </button>
          <Tooltip v-if="m['enabled'] == false && m['message']" class="disabled-tooltip" :showIndicator="false" :tooltipText="m['message']">
            <div></div>
          </Tooltip>
        </div>
      </div>
    </slot>
    <slot name="collapse" v-else>

    </slot>
  </div>
</template>

<script>
export default {
  components: {
  },
  data: function() {
    return {
      showTooltip: '',
      menuOpen: true,
      titleWrap: 'pre-wrap'
    }
  },
  props: {
    arrowRotate: { type: Number, default: 0 },

    // Public Properties
    menu: { type: Array, default: function() { return [] } }, // The array of menus with title and icon.
    // eg: [
    //   { 
    //     title: 'Add', // The title that will show in the button
    //     icon: 'path/to/icon', // the icon of the button
    //     enabled: true, // Default true, set to false to disable the button
    //     visible: true, // Default true, set to false to hide the button
    //     message: '' // The message that will be shown if the button is disabled
    //   }
    // ]
    icon: { type: String, default: 'https://images-na.ssl-images-amazon.com/images/I/417Y8qz6oXL.png' }, // The icon of the menu
    menuWidth: { type: Number, default: 200 }, // The width of the menu
    menuWidthCollapse: { type: Number, default: 40 }, // The width of the menu when it is collapse
    hideIcon: { type: Boolean, default: false }, // The width of the menu

    // Public Events
    // @menuClicked - fired when a menu is clicked from the menu list, returns the name of the menu
  },
  methods: {
    menuClick: function(menu) {
      this.$emit('menuClicked', menu);
    },
    closeClick: function() {
      if (this.arrowRotate == 0) {
        this.menuWidth = 40;
        this.arrowRotate = -180;
      } else {
        this.menuWidth = 200;
        this.arrowRotate = 0;
      }
    },
    menuMouseMove: function(tooltipFor) {
      this.showTooltip = tooltipFor;
    },
  },
  mounted() {
  },
  watch: {
    menuOpen: function(val) {
      if (val) {
        setTimeout(() => this.titleWrap = 'pre-wrap', 200);
      } else {
        this.titleWrap = '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.menus-main {
  background-color: white;
  height: 100%;
  width: 200px;
  border-radius: 5px;
  // border: 1px solid rgba(128,128,128,0.8);
  display: flex;
  padding: 5px;
  align-items: center;
  flex-direction: column;
  position: relative;
  transition: $transition-time;
  z-index: 100;

  .icon {
    height: 30px;
    margin-bottom: 5px;
  }

  > .menu-box-container {
    width: 100%;
    overflow-x: visible;
    overflow-y: auto;

    > .menu-box {
      width: 100%;
      position: relative;
      
      > button {
        width: 100%;
        margin-bottom: 5px;
        text-align: left;
        display: flex;
        padding: 5px;
        white-space: nowrap;
        overflow: hidden;

        &:hover {
          color: white;
          background-color: rgb(80,80,80);
        }

        &:disabled {
          pointer-events: none;
        }

        > .menu-icon {
          height: 20px;
          width: 20px;
          min-width: 20px;
          margin-right: 5px;
        }

        > .menu-hover {
          background-color: rgb(80,80,80);
          position: absolute;
          left: 100%;
          color: white;    
          padding: 3px;
          margin: 0 1px;
          border-radius: 3px;
        }
      }

      > .disabled-tooltip {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: calc(100% - 5px);
      }
    }
  }

  .close-btn {
    position: absolute;
    padding: 2px;
    cursor: pointer;
    border-radius: 5px;
    transition: $transition-time;
    z-index: 99;
    object-fit: contain;
    width: 25px;
    height: 25px;
    top: 5px;

    &:hover {
      background-color: rgba(128,128,128,0.3);
    }
  }
}
</style>